import { getApi } from "./api_instance";

export const completeBids = async (
  { page, pageSize, filterData = null, searchQuery = "" },
  dispatch
) => {
  try {
    filterData = JSON.stringify(filterData);
    return await getApi({
      apiUrl: `/payments/api/transactions/list?filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
